export default __webpack_public_path__ + "static/media/tae.png.webp";